import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Color } from 'ng2-charts';
import 'chartjs-plugin-labels';
@Component({
  selector: 'app-top-content-discuss',
  templateUrl: './top-content-discuss.component.html',
  styleUrls: ['./top-content-discuss.component.scss']
})
export class TopContentDiscuss implements OnInit {

  @Input() dataReport: any

  dtOptions: DataTables.Settings = {};
  title_report = "Top nội dung thảo luận MXH";
  constructor() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      ordering: false,
      searching: false,
      paging: false,
      language: {
        infoEmpty: 'Không tìm thấy dữ liệu',
        infoFiltered: '(trong _MAX_ )',
        info: '',
        lengthMenu: 'Hiển thị _MENU_ ',
        search: 'Tìm kiếm',
        zeroRecords: 'Không có dữ liệu !',
        paginate: {
          first: '<<',
          previous: '<',
          next: '>',
          last: '>>',
        }
      },
      columnDefs: [
        { 'targets': [], 'searchable': false }
      ]
    };
  }
  getWidth(item, seg) {
    let neg = item["neg"];
    let neu = item["neu"];
    let pos = item["pos"];
    let width = ((item[seg] / (neg + neu + pos)) * 100).toFixed(2);
    let result = width;
    if (parseInt(width) < 100) {
      result = (parseFloat(width) - 0.01).toFixed(2);
    }
    return (result + "%");
  }
  checkWidth(item, seg) {
    let neg = item["neg"];
    let neu = item["neu"];
    let pos = item["pos"];
    let width = parseFloat(((item[seg] / (neg + neu + pos)) * 100).toFixed(2));
    if (width >= 30) {
      return true;
    }
    return false;
  }
  ngOnInit(): void {
  };
  ngOnChanges(changes: SimpleChanges) {
    if (this.dataReport && this.dataReport["report_title"]) {
      this.title_report = this.dataReport["report_title"];
    }
  }

}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/reports-component/top-content-discuss/top-content-discuss.component.ts